import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Plani8DataService } from '@monorepo/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, finalize, take } from 'rxjs/operators';
import { TProcessMappingInfoActionType } from './process-mapping.models';
import * as ProcessMappingActions from './process-mapping.actions';
import { from, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProcessMappingEffects {
  constructor(
    private actions$: Actions,
    private plani8DataService: Plani8DataService,
    private appNotificationUtilClass: AppNotificationUtilClass,
  ) {}

  fetchAllProcessess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TProcessMappingInfoActionType.FetchProcessListing),
      switchMap(() => from(this.appNotificationUtilClass.presentLoading()).pipe(take(1))),
      switchMap((loaderEl) =>
        this.plani8DataService.fetchAllProcessess().pipe(
          finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
          map((res) => new ProcessMappingActions.FetchProcessListingSuccess(res)),
          catchError(() => of(new ProcessMappingActions.FetchProcessListingFailure())),
        ),
      ),
    ),
  );

  fetchAllProcessMaps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TProcessMappingInfoActionType.FetchProcessMapListing),
      switchMap(() => from(this.appNotificationUtilClass.presentLoading()).pipe(take(1))),
      switchMap((loaderEl) =>
        this.plani8DataService.fetchAllProcessMaps().pipe(
          finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
          map((res) => new ProcessMappingActions.FetchProcessMapListingSuccess(res)),
          catchError(() => of(new ProcessMappingActions.FetchProcessMapListingFailure())),
        ),
      ),
    ),
  );

  fetchProcessFactoryAssignListing$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TProcessMappingInfoActionType.FetchProcessFactoryAssignListing),
      switchMap(() => from(this.appNotificationUtilClass.presentLoading()).pipe(take(1))),
      switchMap((loaderEl) =>
        this.plani8DataService.getFactoryAssignListing().pipe(
          finalize(() => this.appNotificationUtilClass.dismissLoadingV2(loaderEl)),
          map((res) => new ProcessMappingActions.FetchProcessFactoryAssignListingSuccess(res)),
          catchError(() => of(new ProcessMappingActions.FetchProcessFactoryAssignListingFailure())),
        ),
      ),
    ),
  );
}
